import styled from "styled-components";

const StrategyContainer = styled.div<{visible: boolean}>`
  display: ${(props) => props?.visible ? 'block' : 'none'};
  flex-grow: 1;
`

export default StrategyContainer;
